import { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import useModalClose from "../../hooks/useModalClose";
import { AppContext } from "../../Context/Context";
import { externalLinkNavigator } from "../../util/helper/helperFunctions";
import LogisticsImage from "../../assets/images/logistic.png";
import PerformanceImage from "../../assets/images/performance.png";
import ShipmentImage from "../../assets/images/shipment.png";
import SummaryImage from "../../assets/images/summary.png";
import PairingImage from "../../assets/images/pairing.png";
import YardImage from "../../assets/images/yardview.png";
import AllocatedView from "../../assets/images/allocatedview.png";
import close from "../../assets/icons/close.png";
import "../../assets/css/AdditionalDashboard/additionalDashboard.css";

const EXTERNAL_URLS = [
  {
    label: "Plant Logistics Dashboard",
    icon: LogisticsImage,
    link: "logistics",
    newTab: true
  },
  {
    label: "LGV Performance Summary",
    icon: PerformanceImage,
    link: "performance",
    newTab: true
  },
  {
    label: "Shipment Progress",
    icon: ShipmentImage,
    link: "shipment",
    newTab: true
  },
  {
    label: "LGV Downtime Summary",
    icon: SummaryImage,
    link: "downtime",
    newTab: true
  },
  {
    label: "Active Mixed Pairing",
    icon: PairingImage,
    link: "pairing",
    newTab: true
  },
  {
    label: "Allocated View",
    icon: AllocatedView,
    link: "allocated-view",
    newTab: false
  },
  {
    label: "Yard View",
    icon: YardImage,
    link: "yard-view",
    newTab: false
  }
];

const MODAL_ID = "add-dashboard-wrapper-id";

const AdditionalDashboardModal = () => {
  const { plantCode } = useParams();
  const { plantConfig, setAdditionalDashboardModalIsOpen } =
    useContext(AppContext);

  const closeAdditionalDashboard = () => {
    setAdditionalDashboardModalIsOpen(false);
    document.body.classList.remove("prevent-scroll");
  };

  useModalClose(MODAL_ID, closeAdditionalDashboard);

  const RenderLink = ({ link, label, icon }) => {
    if (link === "yard-view" && !plantConfig?.yard?.isEnabled) {
      return null;
    }
    return (
      <Link
        key={link}
        to={`/${plantCode}/${link}`}
        onClick={closeAdditionalDashboard}
      >
        <div className="add-dashboard-item">
          <img src={icon} alt={`${link}_icon`} />
          <p>{label}</p>
        </div>
      </Link>
    );
  };

  return (
    <div id={MODAL_ID} className="add-dashboard-wrapper">
      <div className="add-dashboard-container">
        <div className="close-section">
          <img
            onClick={closeAdditionalDashboard}
            src={close}
            alt="close_icon"
          />
        </div>
        <div className="dash-items-section">
          {EXTERNAL_URLS.map(({ label, icon, link, newTab }) =>
            newTab ? (
              <a
                key={link}
                href={externalLinkNavigator(link, plantCode)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="add-dashboard-item">
                  <img src={icon} alt={`${link}_icon`} />
                  <p>{label}</p>
                </div>
              </a>
            ) : (
              <RenderLink link={link} icon={icon} label={label} />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default AdditionalDashboardModal;
